export const welfareOfficeBaseData = `
  id
  name
  address {
    street
    number
    zipCode
    city
  }
  phoneNumber
  faxNumber
  email
  dispatchEmail
  maxInvestmentCost
  costObjectNumber
  customCostObjectNumber
`;
